const getSelectedInstances = selected =>
  Object.values(selected?.ids || {})
    .map(value => value?.item ?? value)
    .filter(instance => {
      const instanceId = Number(instance?.id);
      return Number.isInteger(instanceId) && instanceId > 0;
    })
    .filter(
      (instance, index, instances) =>
        instances.findIndex(item => Number(item.id) === Number(instance.id)) ===
        index,
    );

const getSelectedInstanceIds = selected =>
  getSelectedInstances(selected).map(instance => Number(instance.id));

const getSelectedWorkPreviews = selected =>
  getSelectedInstances(selected).map(instance => {
    const artwork = instance?.edition?.artwork;

    return {
      artist:
        artwork?.artists
          ?.map(artist => artist?.name)
          .filter(Boolean)
          .join(", ") ||
        instance?.artistNames ||
        "—",
      id: Number(instance.id),
      image: artwork?.imagesSummary?.imgT || artwork?.images?.[0]?.imgT || null,
      reference: instance?.name || instance?.reference || instance?.ref || "—",
      title: artwork?.title || "—",
    };
  });

export {
  getSelectedInstanceIds,
  getSelectedInstances,
  getSelectedWorkPreviews,
};
